module.exports = require('edge/gateway/billingandpayment/services/GatewayAccountBillingDetailsService')